import qs from "qs";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { post } from "../../api";
import { CHANGE_PASSWORD_BY_HASH } from "../../api/apiRoutes";
import { SubmitHandler, useForm } from "react-hook-form";
import { LOGIN_PAGE } from "../../routes";
import useFacility from "../../../utils/hooks/useFacility";
import { useSelector } from "react-redux";
import { State } from "../../store";

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_WAITING = "CHANGE_PASSWORD_WAITING";

type Inputs = {
  password: string;
  repeatedPassword: string;
};

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const [status, setStatus] = useState<string>(CHANGE_PASSWORD_WAITING);
  const navigate = useNavigate();
  const location = useLocation();
  const facilityIds = useFacility();
  const startPageUrl = useSelector((state: State) => state.config.configuration.startPageUrl);
  // const facilityIds = qs.parse(location.search.slice(1)).facilityIds as string;
  const hash = qs.parse(location.search.slice(1), {
    decoder: (str, decoder, charset, type) => {
      if (type === "value" || type === "key") {
        return decodeURIComponent(str);
      }
      return str;
    },
  }).hash as string;

  const onConfirm: SubmitHandler<Inputs> = async (data) => {
    if (data.password !== data.repeatedPassword) {
      setStatus("Hasła nie mogą się różnić");
    } else {
      setStatus(CHANGE_PASSWORD_WAITING);
      const { isError, errorTable } = await post(CHANGE_PASSWORD_BY_HASH(facilityIds), {
        hash: encodeURIComponent(hash),
        password: data.password,
      });
      if (!isError) {
        if (startPageUrl) {
          window.open(startPageUrl, "_parent");
        } else {
          navigate(`${LOGIN_PAGE}?id=${facilityIds}`);
        }
        setStatus(CHANGE_PASSWORD_SUCCESS);
      } else {
        setStatus(errorTable[0]);
      }
    }
  };

  return { status, onConfirm, register, handleSubmit, errors };
};
